import api from "../../../services/axiosConfig";
import createModuleApi from "../../../services/createModuleApi";

const crud = createModuleApi("/users", {
  endpoints: { list: "" },
});
export const fetchUsers = crud.fetchAll;

export const updateUser = async (id, data) => {
  const res = await api.put(`/users/${id}`, data);
  return res.data;
};

export const assignUserRole = async (userId, roleName) => {
  const res = await api.put(
    `/users/${userId}/roles`,
    {},
    {
      params: { role: roleName },
    },
  );
  return res.data;
};

export const revokeUserRole = async (userId, roleName) => {
  const res = await api.delete(`/users/${userId}/roles`, {
    headers: {
      "Content-Type": "application/json",
    },
    data: {},
    params: { role: roleName },
  });
  return res.data;
};

export const deleteUser = async (id) => {
  const res = await api.delete(`/users/${id}`, {
    headers: {
      "Content-Type": "application/json",
    },
    data: {},
  });
  return res.data;
};

export const addUser = async (newUser) => {
  const res = await api.post("/auth/register", newUser);
  return res.data;
};

export const activateModule = async (userId, moduleLabel) => {
  await api.post("/modules/activate", { userId, moduleLabel });
};

export const deactivateModule = async (userId, moduleLabel) => {
  await api.post("/modules/deactivate", { userId, moduleLabel });
};
